export default __webpack_public_path__ + "static/media/celluloid.2a493a11.gif";